var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isError)?[_vm._t("default",null,null,{ item: _vm.item })]:[_vm._v("\n    "+_vm._s(_vm.$t('this_message_was_replied_from_ads', { ad_id: _vm.adId }))+"\n  ")],_vm._v(" "),(_vm.errorMessages)?[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":"","color":"red"}},on),[_vm._v(" info ")])]}}],null,false,2339016129)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.errorMessages))])])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb0469f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/AdsData.vue
// module id = null
// module chunks = 